import { APIS } from '../../utils/apiConfig';
import { createRequestUtility } from '../../utils/httpUtils';
import { HttpService } from '../HttpService/HttpService';

export class AccountWiseBreakupService {
  // constructor(private httpService: HttpService) {}
  private makeRequest: ReturnType<typeof createRequestUtility>;

  constructor(private httpService: HttpService) {
    // Initialize makeRequest with the httpService
    this.makeRequest = createRequestUtility(this.httpService);
  }

  async getAccountWiseBreakupReport(params: any): Promise<any> {
    return this.makeRequest('post', APIS.GET_ACCOUNTWISE_BREAKUP(), params);
  }
  async downloadServiceOrAccountWiseReport(params: string): Promise<any> {
    return this.makeRequest(
      'post',
      APIS.DOWNLOAD_SERVICE_ACCOUNTWISE_REPORT(),
      params
    );
  }
}
